import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StepsModule } from 'primeng/steps';

import { ModalViewContainerComponent } from './components/modal-view-container.component';

@NgModule({
  declarations: [ModalViewContainerComponent],
  imports: [CommonModule, ButtonModule, RippleModule, StepsModule],
  exports: [ModalViewContainerComponent],
})
export class ModalViewContainerModule {}
